
import React from "react"
import { useNavigate } from 'react-router-dom'
import hotelcss from './css/hotelhotellist.module.css';
import { useEffect } from 'react';
import { useState } from 'react';
import { setErrorMessage, setMessage, clearMessage } from "../tools/errorhandling";
import Button from 'react-bootstrap/Button';
import {
    getallhotels, createregion, getregions, updateregion, deleteregion, linkhoteltoregion, getregionhotels,unlinkhoteltoregion
} from "../dbconnector/connector";
import { confirmAlert } from 'react-confirm-alert';
import { MdEdit, MdDelete } from "react-icons/md";
import { MdOutlineCheck } from "react-icons/md";
import { MdOutlineCancel } from "react-icons/md";


const Regions = (props) => {
    const t = props.translation
    const navigate = useNavigate();
    const [hotels, sethotels] = useState([]);
    const [iconDisabled, setIconDisabled] = useState(false);
    const [selectedregion, setSelectedRegion] = useState({});
    const [hotelsLinkDisabled, setHotelLinkDisabled] = useState(true);
    const [regions, setRegions] = useState({});
    const [regionhotels, setRegionHotels] = useState({});
    const [regionarray, setRegionarray] = useState([]);
    const prevCSS = React.useRef(0)
    const prevSelectedRecord = React.useRef(0)

    //dop something after loading page
    useEffect(() => {
        try {
            LoadRegions()
        } catch (error) {
            setErrorMessage(error.message)
        }
    }, []);

    useEffect(() => {
        setRegionarray([])
        try {
            if (regions.length > 0) {
                regions.forEach((item, index) => {
                    setRegionarray(pre => [...pre,
                    <div id={item.id} className={index % 2 === 0 ? hotelcss.linkVarient1region : hotelcss.linkVarient2region} onClick={iconDisabled ? null : () => selectRegion(item, document.getElementById(item.id))} >
                        <p>{item.name}</p>
                        <p>{item.description}</p>
                        <div className='crudbuttons'>
                            <MdEdit className="topbut" onClick={iconDisabled ? null : () => handleRegionEditClick(item.id, item, index)} />
                            <MdDelete onClick={iconDisabled ? null : () => handleRegionDeleteClick(item.id, item.name)} />
                        </div>
                    </div>
                    ])
                })
            }
        } catch (error) {
            setErrorMessage(error.message)
        }
    }, [regions, iconDisabled]);

    useEffect(() => {
        try {
            document.getElementById("selecthotelactive").checked = true;
            retreivehotels(hotelsLinkDisabled)
        } catch (error) {
            setErrorMessage(t("error_retreivingHotels"))
        }
    }, [hotelsLinkDisabled, regionhotels]);

    function GetLinkedHotels(region) {
        getregionhotels(region).then(res => {
            if (res.status === 200) {
                res.json().then(body => {
                    setRegionHotels(body)
                })
            } else {
                setErrorMessage(res.statusText)
            }
        })
    }

    function selectRegion(region) {
        GetLinkedHotels(region.id);
        setSelectedRegion({})
        setSelectedRegion(region)
        setHotelLinkDisabled(false)
        if (document.getElementById(region.id) !== null) {
            if (prevCSS.current !== undefined && prevSelectedRecord.current !== undefined) {
                if (document.getElementById(prevSelectedRecord.current) && document.getElementById(prevSelectedRecord.current).className !== undefined) {
                    document.getElementById(prevSelectedRecord.current).className = prevCSS.current;
                }
            }

            prevCSS.current = document.getElementById(region.id).className;
            document.getElementById(region.id).className = hotelcss.selectedRegionRow
            prevSelectedRecord.current = region.id
        }
    }

    const handleRegionDeleteClick = (id, name) => {
        const options = {
            title: t("Delete?"),
            message: t("message_deleteregion_1") + name + t("message_deleteRoom_2"),
            buttons: [
                {
                    label: t("Yes"),
                    onClick: () => {
                        const response = deleteregion(id)
                        response.then(res => {
                            console.log(res.ok)
                            if (res.ok) {
                                LoadRegions()
                            }
                        })
                    }
                },
                {
                    label: t("No"),
                }
            ],
            closeOnEscape: true,
            closeOnClickOutside: true,
            keyCodeForClose: [8, 32],
            overlayClassName: "overlay-custom-class-name"
        };

        confirmAlert(options)

    }
    const activechanged = async (id) => {
        retreivehotels(true)
    }

    function retreivehotels(Dissabled) {
        const hotels = getallhotels();
        hotels.then((hotellist) => {
            console.log(hotellist)
            if (hotellist.status === 200) {
                sethotels(hotellist.items)
                Createhotelslist(hotellist.items, navigate, Dissabled, selectedregion);

            } else {
                setErrorMessage(t("error_retreivingHotels"))
            }
        })

    }
    const Createhotelslist = (hotellist, navigate, Dissabled, selectedregion) => {
        let listForHotels = document.getElementById("hotelsList");
        if (listForHotels === null) {
            listForHotels = document.createElement("div");
            listForHotels.id = "hotelsList";
            const upperdiv = document.getElementById("main");
            upperdiv.appendChild(listForHotels);

        } else {
            listForHotels.innerHTML = ""
        }
        const hotellistactivefilter = hotellist.filter(element => !document.getElementById("selecthotelactive").checked ? element.active === 0 : element.active === 1)

        hotellistactivefilter.forEach((hotel, index) => {

            const hotellink = document.createElement("div");
            const Ischecked = document.createElement("input");
            Ischecked.type = "checkbox";
            let linkid= null
            Ischecked.checked = false;
            if(regionhotels.length > 0)
            {
                regionhotels.forEach((item, index) => {
                    if(item.hotel_id === hotel.Hotel_ID)
                    {
                        Ischecked.checked = true;
                        linkid = item.id
                    }
                })
            }
            Ischecked.className = hotelcss.checkbox;
           
            Ischecked.onchange = (e) => LinkHotelToRegion(hotel.Hotel_ID, e, linkid)
            Ischecked.disabled = Dissabled
            hotellink.appendChild(Ischecked);

            //addname element to div
            const IdP = document.createElement("p");
            IdP.className = hotelcss.textalignright;
            IdP.innerText = hotel.nr_afd;
            hotellink.appendChild(IdP);
            const nameP = document.createElement("p");
            nameP.innerText = hotel.Name;
            hotellink.appendChild(nameP);
            const description = document.createElement("p");
            description.innerText = hotel.straatnaam + " " + hotel.huisnummer + ", " + hotel.zipcode + " " + hotel.gemeente;
            hotellink.appendChild(description);

            if (index % 2 === 0) {
                hotellink.className = hotelcss.linkVarient1regionhotel
            } else {
                hotellink.className = hotelcss.linkVarient2regionhotel
            }
            listForHotels.appendChild(hotellink)
        });
    }

    const LoadRegions = () => {
        setRegions([]);
        getregions().then(res => {
            if (res.status === 200) {
                res.json().then(body => {
                    setRegions(body)
                })
            } else {
                setErrorMessage(res.statusText)
            }
        })
    }

    const handleRegionEditClick = (id, item) => {
        setHotelLinkDisabled(true)
        retreivehotels(true)
        setIconDisabled(true)
        const regiondiv = document.getElementById(id)
        regiondiv.innerHTML = ""
        const name = document.createElement("input");
        name.id = "regionname" + id
        name.value = item.name;
        name.className = "inputTable";
        regiondiv.appendChild(name);
        regiondiv.className = hotelcss.linkVarient1region

        const description = document.createElement("input");
        description.id = "regiondescription" + id
        description.value = item.description;
        description.className = "inputTable";
        regiondiv.appendChild(description);

        const savebutton = document.createElement("Button");
        const IconSave = document.getElementById("IconSave").cloneNode(true);
        const IconCancel = document.getElementById("IconCancel").cloneNode(true);

        savebutton.appendChild(IconSave)
        savebutton.className = "AddButtonTable";
        regiondiv.id = "toberemoved"
        regiondiv.appendChild(savebutton);
        savebutton.onclick = () => handleeditregion(id)

        const cancelbutton = document.createElement("Button");
        cancelbutton.appendChild(IconCancel)
        cancelbutton.className = "AddButtonTable";
        cancelbutton.id = "tocancel"
        regiondiv.appendChild(cancelbutton);
        cancelbutton.onclick = () => handleCancelEditRegion()
    }

    const addRegion = () => {

        setIconDisabled(true);
        setHotelLinkDisabled(true)
        const regiondiv = document.createElement("div");

        //addname element to div
        const regionname = document.createElement("input");
        regionname.className = "inputTable";
        regionname.type = "text";
        regionname.id = "regionnameinput";
        regionname.focus();
        regiondiv.appendChild(regionname);
        regiondiv.className = hotelcss.linkVarient1region

        const regiondescription = document.createElement("input");
        regiondescription.className = "inputTable";
        regiondescription.type = "text";
        regiondescription.id = "regiondescriptioninput";
        regiondiv.appendChild(regiondescription);

        const regionarray = document.getElementById("regionarray")
        regionarray.insertBefore(regiondiv, regionarray.firstChild);

        const IconSave = document.getElementById("IconSave").cloneNode(true);
        const IconCancel = document.getElementById("IconCancel").cloneNode(true);

        const addbut = document.createElement("Button");
        addbut.appendChild(IconSave)
        addbut.className = "AddButtonTable";
        regiondiv.id = "inputdiv"
        regiondiv.appendChild(addbut);
        addbut.onclick = handleaddregion;

        const cancelbutton = document.createElement("Button");
        cancelbutton.appendChild(IconCancel)
        cancelbutton.className = "AddButtonTable";
        cancelbutton.id = "tocancel"
        regiondiv.appendChild(cancelbutton);
        cancelbutton.onclick = () => handleCancelRegion()
    }

    const handleeditregion = (id) => {
        setIconDisabled(false);
        const regiondescription = document.getElementById("regiondescription" + id).value
        const regionname = document.getElementById("regionname" + id).value
        try {
            updateregion(id, regiondescription, regionname).then((res) => {
                if (res.status === 200) {
                    LoadRegions();
                } else {
                    setErrorMessage(res.statusText)
                }
            })
        } catch (e) {
            setErrorMessage(e.error)
        }
    }

    const handleaddregion = () => {
        setIconDisabled(false);
        setHotelLinkDisabled(true)
        const regiondescription = document.getElementById("regiondescriptioninput").value
        const regionname = document.getElementById("regionnameinput").value
        try {
            createregion(regiondescription, regionname).then((res) => {
                if (res.status === 200) {
                    LoadRegions();
                    document.getElementById("regionarray").removeChild(document.getElementById("inputdiv"));
                } else {
                    setErrorMessage(res.statusText)
                }
            })
        } catch (e) {
            setErrorMessage(e.error)
        }
    }

    const LinkHotelToRegion = (hotelid, e, linkid) => {
        if (e.target.checked)
        {
            linkhoteltoregion(hotelid, selectedregion.id).then((res) => {
                if (res.status === 200) {
                    //LoadRegions();
                } else {
                    setErrorMessage(res.statusText)
                }

            })
        }
        else{
            if (linkid !== null)
                unlinkhoteltoregion(linkid).then((res) => {
                    if (res.status === 200) {
                        //LoadRegions();
                    } else {
                        setErrorMessage(res.statusText)
                    }
    
                })
        }   
    }
    const handleCancelEditRegion = () => {
        setHotelLinkDisabled(true)
        setIconDisabled(false);
        LoadRegions();
    }
    const handleCancelRegion = () => {
        setIconDisabled(false);
        setHotelLinkDisabled(true)
        document.getElementById("regionarray").removeChild(document.getElementById("inputdiv"))
    }
    return (
        <>
            <div id="main">
                <header>
                    <div id="errordiv" className='error'></div>
                    <div id="coverAllmessage" className="coverall">
                        <div id="messagediv" className='message'>
                            <div id="messagetext" className="MessageText">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean at justo eu risus molestie egestas a rhoncus tellus.
                                Mauris laoreet, dolor at molestie facilisis, metus lorem ornare felis, nec porta sem nulla id dolor. </div>
                            <Button type="button" id="cancelButton" className="OkCancel" onClick={clearMessage}>{t("OK")}</Button>
                        </div>
                    </div>
                </header>
                <div style={{ display: "none" }} id="MyIcons">
                    <MdOutlineCheck id="IconSave" />
                    <MdOutlineCancel id="IconCancel" />
                </div>
                <div id="newuser" className="form">
                    <Button id="addhotelsbutton" onClick={() => addRegion()} disabled={iconDisabled}>{t('Nieuweregio')}</Button>
                </div>
                <div id="filters" className="form" >
                    {/* <label className='formtitleContentBox'>{t('filterinstellingen')}</label>
                    <br></br>
                    <div className="contentbox">
                        <div className="formElement">
                            <label className='labelcolor'>
                                {t('Active')}
                            </label>
                            <input type="checkbox" id="activehotel" className="checkbox"></input>
                        </div>
                        <div className="formElement">
                            <label className='labelcolor'>
                                {t('Naamregio')}
                            </label>
                            <input type="text" id="ZoekOpNaam" placeholder="Search"></input>
                        </div>
                    </div> */}
                    <div className={hotelcss.regionsgrid}>
                        <div id="headertabled" className={hotelcss.regionstableheader}><p id="type">{t('Name')}</p><p id="type">{t('Description')}</p></div>&nbsp;
                        <div id="headertabled" className={hotelcss.hotelregionstableheader}><input id="selecthotelactive" type="checkbox" className={hotelcss.checkbox} onChange={() => activechanged()}></input><p id="status">{t('NR_Dep')}</p><p id="type">{t('Name')}</p><p id="type">{t('Address')}</p></div>
                    </div>
                    <div className={hotelcss.regionsgrid}>
                        <div id="RegionsList" className="list">
                            <div id="regionarray" >{regionarray}</div>
                        </div>&nbsp;
                        <div id="hotelsList" className="list">
                        </div>
                    </div>
                </div>
            </div>
        </>
    )

}

export default Regions